import React, { useEffect, useState } from "react";
import { FormGroup, Button, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { FetchBathroom, UpdateBathroom } from "../../apis/Bathroom";
import { AxiosError } from "axios";

const Bathroom = () => {
  const [updateData, setUpdateData] = useState({
    itemName: "",
    otherItemName: "",
    startValue: "",
    endValue: "",
  });
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bathroom", link: "#" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FetchBathroom();

        if (data && data.bathroom) {
          setUpdateData({
            itemName: data.bathroom.itemName,
            otherItemName: data.bathroom.otherItemName,
            startValue: data.bathroom.startValue,
            endValue: data.bathroom.endValue,
          });
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { itemName, otherItemName, startValue, endValue } = updateData;

      const response = await UpdateBathroom(
        itemName,
        otherItemName,
        startValue,
        endValue,
      );
      if (response) {
        toast.success("bathroom Created Successfully");
        navigate("/bathroom");
      } else {
        toast.error("bathroom Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };
  const validateStartValue = () => {
    return parseFloat(updateData.startValue) > 0
      ? true
      : "Start Value must be greater than 0";
  };
  // Custom validation to ensure endValue is greater than startValue
  const validateEndValue = () => {
    return parseFloat(updateData.endValue) > parseFloat(updateData.startValue)
      ? true
      : "End Value must be greater than Start Value";
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
          <Breadcrumbs title="Add bathroom" breadcrumbItems={breadcrumbItems} />
          <div className="p-6 flex flex-col gap-6 ">
            <h1 className="text-2xl dark:text-[#c7d8eb]">Bathrooms</h1>
            <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
              <AvForm onValidSubmit={handleSubmit}>
                <div className="mb-3">
                  <AvField
                    className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                    name="itemName"
                    label="bathroom Name"
                    placeholder="Type bathroom name"
                    type="text"
                    errorMessage="Enter Name"
                    validate={{ required: { value: true } }}
                    value={updateData.itemName}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        itemName: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                    name="otherItemName"
                    label="Bathroom's other Name"
                    placeholder="Type bathroom's other name"
                    type="text"
                    errorMessage="Enter Name"
                    validate={{ required: { value: true } }}
                    value={updateData.otherItemName}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        otherItemName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                    name="startValue"
                    label="Start value"
                    placeholder="Type start value"
                    type="number"
                    errorMessage="Enter Start Value"
                    validate={{
                      required: { value: true },
                      custom: validateStartValue,
                    }}
                    value={updateData.startValue}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        startValue: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                    name="endValue"
                    label="End Value"
                    placeholder="Type end value"
                    type="number"
                    errorMessage="Enter End Value "
                    validate={{
                      required: { value: true },
                      custom: validateEndValue,
                    }}
                    value={updateData.endValue}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        endValue: e.target.value,
                      })
                    }
                  />
                </div>

                <FormGroup className="mb-0">
                  <div>
                    <Button type="submit" color="primary" className="me-1">
                      Update
                    </Button>
                  </div>
                </FormGroup>
              </AvForm>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Bathroom;
